import Vue from 'vue';
import { REMOTE_PATHS } from './constants/remote-paths.constant';

const getHeaders = () => {
  return {
    Accept: 'application/x-protobuf',
    Authorization: `Bearer ${Vue.prototype.$cookie.get('accessToken')}`
  };
};

const postHeaders = () => {
  const token = Vue.prototype.$cookie.get('accessToken');
  const headers = {
    Accept: 'application/x-protobuf',
    'Content-Type': 'application/x-protobuf'
  };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
};

const constructPath = (path, base) => {
  let prefix;
  if (base) {
    prefix = base;
  } else {
    prefix = REMOTE_PATHS.KCONF_API_PATH;
  }
  return `${prefix}${path}`;
};

const api = {
  _get({ path, params, base }) {
    return Vue.http.get(constructPath(path, base), {
      headers: getHeaders(),
      params,
      responseType: 'arraybuffer'
    });
  },
  _post({ path, body, base }) {
    return Vue.http.post(constructPath(path, base), body, {
      headers: postHeaders(),
      responseType: 'arraybuffer'
    });
  },
  _put({ path, body, base }) {
    return Vue.http.put(constructPath(path, base), body, {
      headers: postHeaders(),
      responseType: 'arraybuffer'
    });
  },
  _patch({ path, body, base }) {
    return Vue.http.patch(constructPath(path, base), body, {
      headers: postHeaders(),
      responseType: 'arraybuffer'
    });
  },
  login(body) {
    return this._post({
      base: REMOTE_PATHS.KCHAT_API_PATH,
      path: '/authentication/log_in',
      body
    });
  },
  getCurrentUser() {
    return this._get({
      path: '/user'
    });
  },
  createSlot(body) {
    return this._post({
      path: '/conference/create_slot',
      body
    });
  },
  muteCall(body, slot_id) {
    return this._put({
      path: `/conference/${slot_id}/mute`,
      body
    });
  },
  muteAll(slot_id) {
    return this._put({
      path: `/conference/${slot_id}/mute_all`
    });
  },
  lockCall(body, slot_id) {
    return this._put({
      path: `/conference/${slot_id}/lock`,
      body
    });
  },
  setTitle(body, slot_id) {
    return this._put({
      path: `/conference/${slot_id}/title`,
      body
    });
  },
  endCall() {
    return this._put({
      path: '/conference/end_conference'
    });
  },
  leaveCall(slot_id, body) {
    return this._put({
      path: `/conference/${slot_id}/end`,
      body
    });
  },
  getGeo() {
    return Vue.http.get('https://freegeoip.net/json/');
  },
  setUsername(body) {
    return this._put({
      path: '/user/username',
      body
    });
  },
  setUserPin(body) {
    return this._put({
      path: '/user/pin',
      body
    });
  },
  getHistory(params) {
    return this._get({
      path: '/conference/history',
      params
    });
  },
  muteUser(body, slot_id) {
    return this._put({
      path: `/conference/${slot_id}/mute_user`,
      body
    });
  },
  kickUser(body, slot_id) {
    return this._post({
      path: `/conference/${slot_id}/kick`,
      body
    });
  },
  putAdminRights(body, slot_id, user_id) {
    return this._put({
      path: `/conference/${slot_id}/admin/${user_id}`,
      body
    });
  },
  sendChatMessage(body, chatChannelName) {
    return this._put({
      path: `/conference/${chatChannelName}/chat`,
      body
    });
  },
  getChatMessages(chatChannelName, params) {
    return this._get({
      path: `/conference/${chatChannelName}/chat`,
      params
    });
  },
  uploadImage(file, onprogress) {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      formData.append('image', file);
      const xhr = new XMLHttpRequest();
      xhr.open('POST', 'https://api.imgur.com/3/upload');
      xhr.onloadend = e => {
        resolve(e.target.response);
      };
      xhr.upload.onprogress = onprogress;
      xhr.send(formData);
    });
  },
  getContacts() {
    return this._post({
      base: REMOTE_PATHS.KCHAT_API_PATH,
      path: '/contacts'
    });
  },
  inviteUser(id, body) {
    return this._post({
      base: REMOTE_PATHS.KCHAT_API_PATH,
      path: `/users/${id}/new_message`,
      body
    });
  },
  getUserInfo(user_id) {
    return this._get({
      base: REMOTE_PATHS.KCHAT_API_PATH,
      path: `/users/${user_id}`
    });
  },
  checkUserSubscription() {
    return this._get({
      path: '/conference/buy'
    });
  },
  startBroadcast(body) {
    return this._post({
      path: '/broadcast/start_broadcast',
      body
    });
  },
  stopBroadcast() {
    return this._post({
      path: '/broadcast/end_broadcast'
    });
  },
  checkBroadcastingStatus() {
    return this._get({
      path: '/broadcast/status'
    });
  }
};

export default api;



// WEBPACK FOOTER //
// ./src/api.js